import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Project, Status, Visibility } from '../../interfaces/project';
import { getProjectImageUrls } from '../../utils/project-images';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router, RouterModule } from '@angular/router';

@Component({
    selector: 'project-card',
    imports: [CommonModule, MatCardModule, MatChipsModule, MatTooltipModule, MatProgressSpinnerModule, RouterModule],
    templateUrl: './project-card.component.html',
    styleUrl: './project-card.component.sass'
})
export class ProjectCardComponent {
  /** Keep in sync with `$card-title-size` and `$card-spinner-size` in project-card.component.sass */
  private static readonly cardTitleRem = 2;
  private static readonly spinnerToTitleRatio = 1.5;

  /** px diameter = 1.5× title em box (16px root → 2rem title → 48px ring). */
  readonly headerSpinnerDiameter = Math.round(
    ProjectCardComponent.cardTitleRem * 16 * ProjectCardComponent.spinnerToTitleRatio
  );

  @Input({ required: true }) project!: Project;
  @Input({ required: false }) selectedCategoryFilters: string[] = [];
  @Input({ required: false }) selectedStatusTagFilters: string[] = [];
  /** When true and project is hidden, show a Private label (user can see it in the list). */
  @Input({ required: false }) showPrivateBadge = false;
  @Output() categoryFilterEvent = new EventEmitter<string>();
  @Output() statusTagFilterEvent = new EventEmitter<string>();

  readonly Visibility = Visibility;

  constructor(private router: Router) {}

  toggleCategoryFilter(category: string): void {
    this.categoryFilterEvent.emit(category);
  }

  toggleTagFilter(tag: string): void {
    this.statusTagFilterEvent.emit(tag);
  }

  navigateToProjectPage() {
    this.router.navigate(['/projects', this.project.id]);
  }

  /** ⅓ planned, ⅔ active + on hold, 100% finished */
  statusProgress(status: Status): number {
    switch (status) {
      case Status.planned:
        return 100 / 3;
      case Status.active:
      case Status.on_hold:
        return (200 / 3);
      case Status.archived:
        return 100;
      default:
        return 0;
    }
  }

  /** First image in the ordered URL list (cover, or first gallery line if no cover). */
  listingImageUrl(project: Project): string | undefined {
    return getProjectImageUrls(project)[0];
  }
}
